<template>
    <div class="page-container">
        <!-- <div class="area-container">
            <el-scrollbar>
                <el-tree
                    ref="area_tree"
                    node-key="id"
                    :data="treeData"
                    :props="{
                        label: 'name',
                        children: 'children'
                    }"
                    :expand-on-click-node="false"
                    :default-expanded-keys="default_expanded_keys"
                    highlight-current
                    @node-click="handleNodeClick"
                />
            </el-scrollbar>
        </div> -->
        <div class="data-container">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="getTableData">刷新</el-button>
                <el-button type="primary" :icon="Plus" plain @click="handleAdd" v-permission="['heating:data-push:add']">
                    添加
                </el-button>
            </div>
            <el-table class="data-table" :data="table_data" v-loading="tableLoading">
                <el-table-column label="序号" type="index" fixed="left" width="50px"></el-table-column>
                <el-table-column label="单位" min-width="100" prop="school_name"></el-table-column>
                <el-table-column label="区域" min-width="100" prop="building_name"></el-table-column>
                <el-table-column label="AppKey" min-width="100" prop="appKey"></el-table-column>
                <el-table-column label="AppSecret" min-width="150" prop="appSecret"></el-table-column>
                <el-table-column label="操作" fixed="right" width="230">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            :icon="View"
                            link
                            size="small"
                            @click="viewDetail(row)"
                            v-permission="['heating:data-push:detail']"
                        >
                            详情
                        </el-button>
                        <el-button
                            type="primary"
                            :icon="Edit"
                            link
                            size="small"
                            @click="handleEdit(row)"
                            v-permission="['heating:data-push:edit']"
                        >
                            编辑
                        </el-button>
                        <el-button
                            type="primary"
                            :icon="Document"
                            link
                            size="small"
                            @click="delOpenAppManageFn(row.id)"
                            v-permission="['heating:data-push:push-log']"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <forms-dialog
                v-model="formDialogVisible"
                :isForm="isForm"
                :modelId="selectModelId"
                :current_node_id="current_node?.id"
                :detailData="detail_data"
                :treeData="treeData"
                @updateForm="getTableData"
            />
        </div>
    </div>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import { Document, Edit, Plus, Refresh, Upload, View } from '@element-plus/icons'
import FormsDialog from './components/forms.vue'
import { getOpenAppLists, delOpenAppManage } from '@/api/open_app.js'
import { ElMessageBox, ElMessage } from 'element-plus'

// 区域树形数据
const area_tree = ref(null)
const treeData = ref([])
const default_expanded_keys = ref([])

//点击树形节点
const current_node = ref(null)
const handleNodeClick = (node) => {
    current_node.value = node
    getTableData()
}

const table_data = ref([])
const tableLoading = ref(false)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    getOpenAppLists().then((data) => {
        table_data.value = data
    })
}

// 表单弹窗
const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectModelId = ref('') // 点中的模块id
const detail_data = ref({})

// 添加
function handleAdd() {
    isForm.value = true
    selectModelId.value = ''
    detail_data.value = {}
    formDialogVisible.value = true
}

// 查看详情
function viewDetail(row) {
    isForm.value = false
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}

// 编辑服务
function handleEdit(row) {
    isForm.value = true
    selectModelId.value = row.id
    detail_data.value = row
    formDialogVisible.value = true
}
function delOpenAppManageFn(id) {
    ElMessageBox.confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(() => {
            delOpenAppManage(id).then(() => {
                ElMessage.success('删除成功')
                getTableData()
            })
        })
        .catch(() => {
            ElMessage.info('已取消删除')
        })
}

// 推送日志页面
const pushLogVisible = ref(false)

// 推送日志
function viewPushLog(row) {
    selectModelId.value = row.id
    pushLogVisible.value = true
}

onMounted(() => {
    getTableData()
})
</script>

<style lang="scss" scoped>
.push-log-container {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
}
</style>
